export interface ParkingDurationInfo {
  parkingDurationStart: string;
  parkingDurationEnd: string;
  parkingDurationDuration: string;
}

export const extractParkingDurationInfo = (parkingDurationString: string): ParkingDurationInfo => {
  const startMatch = parkingDurationString.match(/Parking start \/ Falschparkbeginn:\s*(.+?)(?:\n|$)/);
  const endMatch = parkingDurationString.match(/Parking end \/ Falschparkende:\s*(.+?)(?:\n|$)/);
  const durationMatch = parkingDurationString.match(/Parking duration \/ Falschparkdauer:\s*(.+?)(?:\n|$)/);
  
  return {
    parkingDurationStart: startMatch ? startMatch[1].trim() : '',
    parkingDurationEnd: endMatch ? endMatch[1].trim() : '',
    parkingDurationDuration: durationMatch ? durationMatch[1].trim() : ''
  };
};